import { useEffect } from "react";
import { initLenis, destroyLenis } from "@/lib/lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HighlightReel from "@/components/HighlightReel";
import WhoFor from "@/components/WhoFor";
import WhatYouGet from "@/components/WhatYouGet";
import AboutCoach from "@/components/AboutCoach";
import Philosophy from "@/components/Philosophy";
import Testimonials from "@/components/Testimonials";
import LimitedCTA from "@/components/LimitedCTA";
import ApplicationForm from "@/components/ApplicationForm";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="bg-[#0B0B0C] text-white min-h-screen" data-testid="landing-page">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HighlightReel />
        <WhoFor />
        <WhatYouGet />
        <AboutCoach />
        <Philosophy />
        <Testimonials />
        <LimitedCTA />
        <ApplicationForm />
      </main>
      <Footer />
    </div>
  );
}
